import React from 'react';
import wb0 from '../img/Detail/cleaner-detail.jpg';
import './Detail.css';
const CleanerDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default CleanerDetail;